import { createSelector } from 'reselect'

export const getAppLoading = createSelector(
  state => Boolean(state && state.common && state.common.transitions && state.common.transitions.isLoading),
  isLoading => isLoading
)
